import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AUDIT_LOG_SEARCH_RESOURCE } from "../audit-log/use-audit-log-search.query";
import { getOpenPositionDunningBlockPath } from "./use-open-position-dunning-block-create.mutation";
import { OPEN_POSITION_RESOURCE } from "./use-open-position-search.query";

export function useOpenPositionDunningBlockDeleteMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { openPositionUuid: string }>({
    mutationFn: async ({ openPositionUuid }) => {
      await alphartisApiAxios.delete(getOpenPositionDunningBlockPath(openPositionUuid));
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [OPEN_POSITION_RESOURCE] }),
        queryClient.invalidateQueries({ queryKey: [AUDIT_LOG_SEARCH_RESOURCE] }),
      ]);
    },
  });
}
